module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Downloads-folder-3f3dff058e0e4df46013e2a590540e6f.svg";